import type { ReactElement } from 'react';

import { ContactsPage as ContactsFeaturePage } from '../features/contacts/pages/ContactsPage.js';

export default function ContactsPage(): ReactElement {
  return <ContactsFeaturePage />;
}
